import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { UIManager } from "../UIManager";
import { CheckBox, CheckBoxInput } from "./CheckBox";
import { ControlParams } from "./ControlInterfaces";

export class CheckBox2s extends CheckBox {
    constructor(params: ControlParams) {
        super(params);
        this.element.classList.add("CheckBox2s");
    }

    protected override _createCheckBox(): CheckBoxInput {
        const checkBox = createElement({ type: "input", attrs: { "type": "checkbox" } }) as CheckBoxInput;
        checkBox.indeterminate = true;
        checkBox.id = UIManager.instance.generateElementID();

        Object.defineProperty(checkBox, "tscValue", {
            get: function() {
                return !(this as Element).getAttribute("value") ? null : (this as Element).getAttribute("value") === "true"; /* atribut value má vždy textovou hodnotu */
            },
            set: function(value: boolean | string | number) {
                const t: CheckBoxInput = this as CheckBoxInput;
                switch (value) {
                    case true:
                    case "true":
                    case 1:
                        t.setAttribute("value", "true");
                        t.indeterminate = false;
                        t.checked = true;
                        break;

                    // checked na unchecked
                    case false:
                    case "false":
                    case 0:
                    default:
                        t.setAttribute("value", "false");
                        t.indeterminate = false;
                        t.checked = false;
                        break;
                }
            },
        });

        checkBox.tscValue = false; //pocatecni hodnota checkboxu

        checkBox.addEventListener("click", this._listenerClick = (e) => {
            const t = e.target as CheckBoxInput;
            const owner = (t.parentNode as any).tscControl as CheckBox;

            if ((!owner || owner.isEditing) && !checkBox.readOnly) {
                switch (t.tscValue) {
                    case false:
                        t.tscValue = true;
                        break;
                    // checked na unchecked
                    case true:
                        t.tscValue = false;
                        break;
                }

                if (owner)
                    owner.valueChanged.trigger(owner, t.tscValue);
            }
        });

        return checkBox;
    }
}
